export const COMMAND_SECTIONS = {
  CREATE: 'create',
  NAVIGATION: 'navigation',
  HOMEYS: 'homeys',
  CONTEXT_NAVIGATE: 'context-navigate',
  CONTEXT_ACTIONS: 'context-actions',
  CONTEXT_DEVELOPER: 'context-developer',
  SETTINGS_ACTIONS: 'settings-actions',
  SETTINGS_SYSTEM: 'settings-system',
  SETTINGS_INTEGRATIONS: 'settings-integrations',
  SETTINGS_APPS: 'settings-apps',
  APP_ACTIONS: 'app-actions',
  DEVICES: 'devices',
  FLOWS: 'flows',
  LOGS: 'logs',
  DEVICE_ACTIONS: 'device-actions',
  FLOW_ACTIONS: 'flow-actions',
} as const;

export type CommandSection = (typeof COMMAND_SECTIONS)[keyof typeof COMMAND_SECTIONS];

export const COMMAND_SECTION_ORDER: CommandSection[] = [
  COMMAND_SECTIONS.CREATE,
  COMMAND_SECTIONS.NAVIGATION,
  COMMAND_SECTIONS.CONTEXT_NAVIGATE,
  COMMAND_SECTIONS.CONTEXT_ACTIONS,
  COMMAND_SECTIONS.CONTEXT_DEVELOPER,
  COMMAND_SECTIONS.SETTINGS_ACTIONS,
  COMMAND_SECTIONS.HOMEYS,
  COMMAND_SECTIONS.SETTINGS_SYSTEM,
  COMMAND_SECTIONS.SETTINGS_INTEGRATIONS,
  COMMAND_SECTIONS.SETTINGS_APPS,
  COMMAND_SECTIONS.APP_ACTIONS,
  COMMAND_SECTIONS.DEVICE_ACTIONS,
  COMMAND_SECTIONS.DEVICES,
  COMMAND_SECTIONS.FLOW_ACTIONS,
  COMMAND_SECTIONS.FLOWS,
  COMMAND_SECTIONS.LOGS,
];

export const COMMAND_SECTION_LABEL_KEYS: Readonly<Record<string, string>> = {
  [COMMAND_SECTIONS.CREATE]: 'common.create',
  [COMMAND_SECTIONS.NAVIGATION]: 'commandPalette.sections.navigation',
  [COMMAND_SECTIONS.HOMEYS]: 'commandPalette.sections.homeys',
  [COMMAND_SECTIONS.CONTEXT_NAVIGATE]: 'commandPalette.sections.navigate',
  [COMMAND_SECTIONS.CONTEXT_ACTIONS]: 'common.actions',
  [COMMAND_SECTIONS.CONTEXT_DEVELOPER]: 'commandPalette.sections.developer',
  [COMMAND_SECTIONS.SETTINGS_ACTIONS]: 'common.actions',
  [COMMAND_SECTIONS.SETTINGS_SYSTEM]: 'commandPalette.sections.settingsSystem',
  [COMMAND_SECTIONS.SETTINGS_INTEGRATIONS]: 'commandPalette.sections.settingsIntegrations',
  [COMMAND_SECTIONS.SETTINGS_APPS]: 'commandPalette.sections.settingsApps',
  [COMMAND_SECTIONS.APP_ACTIONS]: 'commandPalette.sections.appActions',
  [COMMAND_SECTIONS.DEVICES]: 'navigation.devices',
  [COMMAND_SECTIONS.FLOWS]: 'scopes.flow',
  [COMMAND_SECTIONS.LOGS]: 'scopes.insights',
  [COMMAND_SECTIONS.DEVICE_ACTIONS]: 'common.actions',
  [COMMAND_SECTIONS.FLOW_ACTIONS]: 'common.actions',
} satisfies Record<CommandSection, string>;
